/**
 * # cortex:react-ui-std:helper:StyleSheetController
 * Deprecated: Use Cellula components instead
 */
export class StyleSheetController {
	private readonly styleElement: HTMLStyleElement;
	private readonly styles = new Set<string>();

	constructor() {
		this.styleElement = document.createElement('style');
		this.styleElement.type = 'text/css';
		this.styleElement.appendChild(document.createTextNode(''));

		document.head.appendChild(this.styleElement);
	}

	public addToRegister(selector: string, style: string): StyleSheetController {
		const cssStyleSheet = this.styleElement.sheet as CSSStyleSheet;

		if (this.styles.has(selector)) return this;

		this.styles.add(selector);

		const newCSSVariables = `
			${selector} {
        ${style}
			}
    `;

		cssStyleSheet.insertRule(newCSSVariables, cssStyleSheet.cssRules.length);

		return this;
	}
}
